import { Injectable } from '@angular/core';
import { ActionReducerMap, combineReducers } from '@ngrx/store';
import { UI_REDUCER } from '@safarilaw-webapp/shared/redux';
import { IRmsUiState } from './state.interface';
import { RmsPortalPageUiReduxObject } from '../portal/redux/state';
import { RmsIntakePageUiReduxObject } from '../serve/redux/state';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';
import { RmsDefaultPageReduxUiObject } from './default-page-ui-state';

/* __SAFARI_SCHEMATICS (IMPORTS)__ */

// Technically this service only exists for LPMS feature, but because its used during the initialization
// it can't be declared as provided in FeatureLpmsUiModule since it would result in a dependency to itself before initializing
@Injectable()
export class RmsUiReducerService extends SafariInjector {
  private _rmsPortalPageUiReduxObject: RmsPortalPageUiReduxObject;
  private _rmsIntakePageUiReduxObject: RmsIntakePageUiReduxObject;
  private _defaultPageReduxObject: RmsDefaultPageReduxUiObject;
  constructor() {
    super();
    this._rmsPortalPageUiReduxObject = this.inject(RmsPortalPageUiReduxObject);
    this._rmsIntakePageUiReduxObject = this.inject(RmsIntakePageUiReduxObject);
    this._defaultPageReduxObject = this.inject(RmsDefaultPageReduxUiObject);
  }
  get reducers() {
    /* EXAMPLE OF ADDING NEW MODEL FROM API - LOCATIONS THAT NEED TO BE UPDATED */
    const reducers: ActionReducerMap<IRmsUiState> = {
      pages: combineReducers({
        portalPageUiState: UI_REDUCER(this._rmsPortalPageUiReduxObject),
        intakePageUiState: UI_REDUCER(this._rmsIntakePageUiReduxObject),
        defaultPageState: UI_REDUCER(this._defaultPageReduxObject)
      })
    };
    return reducers;
  }
}
